<template>
  <div id="app">
        <router-view/>
        <!-- <router-view name="Home" :productLists="productList"></router-view> -->
  </div>
</template>

<script>


export default {
  name: 'App',
  data() {
      return {
     
      }
    },
  created() {
 
  }
}
</script>

<style>

</style>
